<ng-container *ngIf="envioCorreoFrChedD">
    <div class="nota-info warning ched-d mb-2">
        <span class="imagen-alerta"></span>
        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Es necesario presentar en Traces la solicitud de obtención de CHED-D</label>
    </div>
</ng-container>
